"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconActionChevronLeft = _interopRequireDefault(require("../Icons/IconActionChevronLeft"));

var _IconActionChevronRight = _interopRequireDefault(require("../Icons/IconActionChevronRight"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  cursor: ", ";\n  padding: 4px 5px;\n  margin: 0 2px;\n  background-color: ", ";\n  display: block;\n  border-radius: 5px;\n  color: ", ";\n  font-size: 1.4rem;\n  line-height: 130%;\n  transition: color 0.15s ease-in-out;\n  text-decoration: none;\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 15px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  text-decoration: none;\n\n  &:first-of-type {\n    border-right: 1px solid #e4e4e4;\n    padding-right: 10px;\n  }\n\n  &:last-of-type {\n    border-left: 1px solid #e4e4e4;\n    padding-left: 10px;\n  }\n\n  svg {\n    transform: scale(0.5);\n  }\n\n  .label {\n    font-size: 1.4rem;\n    line-height: 1.7rem;\n    letter-spacing: 0.04em;\n    color: ", ";\n    transition: 0.15s ease-in-out;\n  }\n\n  &:hover {\n    .label {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  font-family: ", ";\n  justify-content: center;\n  border: 1px solid #e4e4e4;\n  background-color: white;\n  overflow: hidden;\n  border-radius: 5px;\n  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.1);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
      totalPages = _ref.totalPages,
      pageLength = _ref.pageLength,
      base = _ref.base,
      otherFilters = _ref.otherFilters,
      otherProps = _objectWithoutProperties(_ref, ["currentPage", "totalPages", "pageLength", "base", "otherFilters"]);

  var urls = [];

  for (var index = 1; index <= totalPages; index++) {
    var generatedUrl = "".concat(base).concat(index);
    var pageNumber = index;
    urls[index] = {
      url: generatedUrl,
      page: pageNumber
    };
  }

  var prevUrl = currentPage - 1;
  var nextUrl = currentPage + 1;
  return _react.default.createElement(PaginationWrapper, otherProps, currentPage > 1 ? _react.default.createElement(PaginationButton, {
    to: urls[prevUrl].url
  }, _react.default.createElement(_IconActionChevronLeft.default, {
    color: "#C1C1C1"
  }), _react.default.createElement("span", {
    className: "label"
  }, "Prev")) : '', _react.default.createElement(PaginationPages, null, currentPage > 4 ? _react.default.createElement(PaginationPage, {
    to: urls[1].url
  }, "1") : '', currentPage > 4 ? _react.default.createElement(PaginationPage, {
    disabled: true
  }, "...") : '', urls.map(function (url) {
    return url.page >= currentPage - 2 && url.page <= currentPage + 2 ? _react.default.createElement(PaginationPage, {
      to: url.url,
      key: url.page,
      active: url.page === currentPage ? true : false
    }, url.page) : '';
  }), currentPage < totalPages - 3 ? _react.default.createElement(PaginationPage, {
    disabled: true
  }, "...") : '', currentPage < totalPages - 3 ? _react.default.createElement(PaginationPage, {
    to: urls[totalPages].url
  }, totalPages) : ''), currentPage < totalPages ? _react.default.createElement(PaginationButton, {
    to: urls[nextUrl].url
  }, _react.default.createElement("span", {
    className: "label"
  }, "Next"), _react.default.createElement(_IconActionChevronRight.default, {
    color: "#C1C1C1"
  })) : '');
};

var PaginationWrapper = _styledComponents.default.div(_templateObject(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var PaginationButton = (0, _styledComponents.default)(_reactRouterDom.Link)(_templateObject2(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.typo.interactive;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.brand.primary;
});

var PaginationPages = _styledComponents.default.div(_templateObject3());

var PaginationPage = (0, _styledComponents.default)(_reactRouterDom.Link)(_templateObject4(), function (_ref5) {
  var active = _ref5.active,
      disabled = _ref5.disabled;
  return active || disabled ? 'default' : 'pointer';
}, function (_ref6) {
  var active = _ref6.active,
      theme = _ref6.theme;
  return active ? theme.brand.primary : 'white';
}, function (_ref7) {
  var active = _ref7.active,
      theme = _ref7.theme;
  return active ? 'white' : theme.typo.interactive;
}, function (_ref8) {
  var theme = _ref8.theme,
      active = _ref8.active,
      disabled = _ref8.disabled;
  return active ? 'white' : disabled ? theme.typo.interactive : theme.brand.primary;
});
Pagination.propTypes = {
  /** The current page the pagination component should show. */
  currentPage: _propTypes.number.isRequired,

  /** Total amount of pages possible. */
  totalPages: _propTypes.number.isRequired,

  /** Records shown per page. */
  pageLength: _propTypes.number.isRequired,

  /** URL on which the pagination is to be based. */
  base: _propTypes.string,

  /** Extra filters to be passed to the URL. */
  otherFilters: _propTypes.string
};
Pagination.defaultProps = {
  currentPage: 1,
  totalPages: 1,
  pageLength: 20
};
var _default = Pagination;
exports.default = _default;